import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=3226400c&scoped=true&"
import script from "./Exhibition.vue?vue&type=script&lang=ts&"
export * from "./Exhibition.vue?vue&type=script&lang=ts&"
import style0 from "./Exhibition.vue?vue&type=style&index=0&id=3226400c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3226400c",
  null
  
)

export default component.exports